module.exports = __webpack_public_path__ + "static/media/shelter_anchorage_3.2a012dbb.svg";